import React from 'react'
import { Images } from '../../../utils/imageConstants'

interface SuggestedQuestion {
  icon: string
  text: string
}

interface WelcomeSectionProps {
  suggestedQuestions: SuggestedQuestion[]
  onQuestionClick: (questionText: string) => void
}

const WelcomeSection: React.FC<WelcomeSectionProps> = ({
  suggestedQuestions,
  onQuestionClick
}) => {
  return (
    <div className="statgpt-welcome-section">
      <div className="statgpt-welcome-header">
        <h1 className="statgpt-welcome-title">Hello Jay,</h1>
        <p className="statgpt-welcome-subtitle">Welcome to StatGPT</p>
      </div>

      <div className="statgpt-questions-grid">
        {suggestedQuestions.map((question, index) => (
          <div 
            key={index} 
            className="statgpt-question-card"
            onClick={() => onQuestionClick(question.text)}
            style={{ cursor: 'pointer' }}
          >
            <div className="statgpt-question-icon-wrapper">
              <div className="statgpt-question-icon-mask">
                <div 
                  className="statgpt-question-icon" 
                  style={{ maskImage: `url('${question.icon}')` }}
                />
              </div>
            </div>
            <p className="statgpt-question-text">{question.text}</p>
          </div>
        ))}
      </div>
    </div>
  )
}

export default WelcomeSection

